import * as configcat from 'configcat-js';

let configCatClient: configcat.IConfigCatClient | null = null;

export function createConfigCatClient(userId: string, userEmail: string) {
    const configCatUser = new configcat.User(userId, userEmail);

    if (configCatClient) {
        configCatClient.setDefaultUser(configCatUser);
    } else {
        const logger = configcat.createConsoleLogger(configcat.LogLevel.Warn);
        configCatClient = configcat.getClient(
            import.meta.env.VITE_CONFIGCAT_SDK_KEY,
            configcat.PollingMode.AutoPoll,
            {
                logger: logger,
                defaultUser: configCatUser
            }
        );
    }

    return configCatClient;
}
